export default "__VITE_ASSET__DM1NE3is__"